import React from 'react'
import { LoginContainer, LeftForm, RightCover } from './styles'

const LoginTemplate = props => (
  <LoginContainer>
    <LeftForm>
      {props.leftForm}
    </LeftForm>
    <RightCover>
      {props.cover}
    </RightCover>
  </LoginContainer>
)

export default LoginTemplate
